export const generateArray = (length: number, startsFrom?: number) =>
  Array.from({ length }, (_, i) => (startsFrom ? i + startsFrom : i));

export const getProfitStatus = (num: string) => {
  const number = parseFloat(num);
  return number > 0 ? 'positive' : number === 0 ? 'zero' : 'negative';
};
